'use strict';

import $ from 'jquery';
import _ from 'underscore';
import cookies from 'js-cookie';
import config from '../../js/config';
import mediator from '../../js/mediator';
import logger from 'loglevel';

let log = logger.getLogger('Sitecore');

export class ContentServiceApi {
  getSingleItem(guid) {
    if (!guid || !guid.toString().match(/^\{?[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\}?$/i)) throw 'Invalid GUID ' + guid;
    return $.get(`${config.urls.contentService.singleItem}/` + guid).promise();
  }
}

/* placeholder for something that's smarter about error-handling, which may be MVC errors from asp.net, Web Api 2 errors from asp.net, 500s
   from external apis, etc..  Here we only use Content Api from sitecore which returns plain text */
export function ProcessError(error) {
  return error;
};


export function ProcessSitecoreFields($parent,authority) {
  let language = cookies.get(config.cookies.arrowLanguage);
  let deferreds = [];
  $parent.find('[data-sitecore-item]').each((i,itemElement) => {
    let $itemElement = $(itemElement);
    // >.>
    var sitecoreItemName = $itemElement.data('sitecoreItem');
    let item = (authority && typeof authority[sitecoreItemName] !== 'undefined') ? authority[sitecoreItemName] : null;
    if (!item || !item.itemID) return;
    let itemId = item.itemID;
    let fieldLookup = {};
    let fields = [];
    // we want to process all the DOM elements with data-sitecore-field
    // we'll build a lookup by item id of the distinct items, in which each
    //  item has a field lookup so we have this lookup table of distinct
    //  itemids and the fields in those items
    // the lookup table looks like this:
    // xxx-xxxx-xxx-xx: {
    //   l: 'en',
    //   i: 'xxx-xxxx-xxx-xx',
    //   f: {
    //      name: true,
    //      title: true,
    //   }
    // }
    // yyy-yyyy-yyy-yy: {
    //   l: 'en',
    //   i: 'yyy-yyyy-yyy-yy',
    //   f: {
    //      author: true,
    //      content: true,
    //   }
    // }
    // where xx..xx and yy..yy represent item names
    let addField = (itemId,fieldName) => {
      let field = fieldLookup[itemId];
      if (typeof field === 'undefined') {
        field = {
          l: language,
          i: itemId,
          f: { fieldName: true }
        };
        fieldLookup[itemId] = field;
        fields.push(field);
      }
      if (typeof field.f[fieldName] === 'undefined') {
        field.f[fieldName] = true;
      }
    };
    // go through and build the lookup table
    $itemElement.find('[data-sitecore-field]').each((i,fieldElement) => {
      let $fieldElement = $(fieldElement);
      addField(itemId,$fieldElement.data('sitecoreField'));
    });
    // convert the lookup table into an array to request all fields:
    // (continuing above):
    // [ { i: 'xx..xx', l: 'en', f: [ 'name', 'title' ] },
    //   { i: 'yy..yy', l: 'en', f: [ 'author', 'content' ] } ]
    _.each(fieldLookup, (field) => {
      // convert the field lookup into an array of the distinct fields
      field.f = _.allKeys(field.f);
    });
    deferreds.push($.ajax(config.urls.contentService.ajaxField,{
      'method': 'POST',
      'dataType': 'json',
      'data': JSON.stringify(fields)
    }).then((fieldResults) => {
      $itemElement.find('[data-sitecore-field]').each((i,fieldElement) => {
        let $fieldElement = $(fieldElement);
        let key = itemId + '~' + language + '~' /* + version */ + '~'
         + $fieldElement.data('sitecoreField');
        if (typeof fieldResults[key] !== 'undefined') {
          $fieldElement.replaceWith(fieldResults[key]);
        }
      });
    }).fail((e) => {
      log.error(`bad stuff happened with fields on ${itemId}!`);
      log.error(e);
    }));
  });
  let globalPlaceholder = $parent.data('placeholderContext');
  if (globalPlaceholder) {
    $parent.find('[data-placeholder]').each((i,fieldElement) => {
      let $fieldElement = $(fieldElement);
      let data = {
        placeholder: `${globalPlaceholder}/${$fieldElement.data('placeholder')}`
      }
      let dynamicPlaceholder = $fieldElement.data('dynamicPlaceholder');
      if (dynamicPlaceholder) {
        data.dynamic = true;
        // implement dynamic placeholder logic - by default we concatenate the current rendering id to the placeholder name to
        //  generate a dynamic placeholder value.  For UI controls which have been ported, this will be the original sitecore
        //  rendering id.  For new stuff, it will be the id of the AjaxRendering (under Data in the content tree).
        data.currentRenderingId = authority.renderingUniqueId;
        let renderingIdOverride = $fieldElement.data('renderingIdOverride');
        if (renderingIdOverride) {
          data.renderingIdOverride = renderingIdOverride;
        }
      }
      let label = $fieldElement.data('placeholderLabel');
      if (label) {
        data.label = label;
      }
      deferreds.push($.ajax('',{
        'method': 'POST',
        'dataType': 'html',
        'data': data
      }).then((placeholderResults) => {
        let $placeholderResults = $('<div>');
        $placeholderResults.append(placeholderResults);
        $fieldElement.replaceWith($placeholderResults);
        mediator.trigger(config.events.ui.sitecorePlaceholderLoaded, $placeholderResults);
      }).fail((e) => {
        log.error('bad stuff happened with placeholders!');
        log.error(e);
      }));
    });
  }
  // yucko - if any of our placeholders themselves had AjaxRenderingStack in them, they would've replaced the deferred.  If when we are done with all the deferred
  // the window deferred object is the same, we can resolve it (which triggers the onload method).
  $.when(deferreds).then(() => {
    if (window.AjaxRenderingStack) {
      window.AjaxRenderingStack.pop();
      if (!window.AjaxRenderingStack.length) {
        delete window.AjaxRenderingStack;
        if (window.OldOnLoad) {
          window.OldOnLoad();
          delete window.OldOnLoad;
        }
      }
    }
  });
}

export function isInExperienceEditor() {
  // c.f. http://getfishtank.ca/en/blog/detect-sitecore-pageeditor-mode-using-javascript-jquery
  return !!(window.Sitecore && window.Sitecore.PageModes && window.Sitecore.PageModes.PageEditor);
};

let safeCssClass = (displayClass) => {
  if (!displayClass) return '';
  return displayClass.cssClass;
}

export function imageImportanceFormattedCss(imageImportance) {
  if (!imageImportance) return '';
  if (!imageImportance.horizontalImportance) return '';
  if (!imageImportance.verticalImportance) return '';

  let prefixCss = 'u-bg-align-';

  return prefixCss + safeCssClass(imageImportance.verticalImportance) + '-' + safeCssClass(imageImportance.horizontalImportance);
}



// WEBPACK FOOTER //
// ./assets/components/Sitecore/Sitecore.js